// 特定の要素のクリックログをサーバに送信する
// 使い方: data-click-logを計測したい要素に追加する。data-click-log内に下記を指定する。
//   tag: 要素を識別するためのタグ。一意。
//   action: 任意。ログ送信のHTTPメソッド。'get' or 'post'。デフォルトは'post'。
//   path: ログ送信先のパス。
//   request_id: 任意。PVのリクエストID。どのPVに紐づくものか判別できるようにするためのもの。
//   count_only_once: 任意。trueにすると、要素がクリックされた最初の1回だけログを送信する。デフォルトはfalse。
jQuery(function ($) {
  // data-click-logをパース
  const parseClickLogData = (element) => {
    try {
      const dataAttr = element.getAttribute('data-click-log')
      return dataAttr ? JSON.parse(dataAttr) : null
    } catch (error) {
      console.error('Invalid data-click-log format:', error)
      return null
    }
  }

  // ログを送る
  class Logger {
    constructor(action, logPath, requestId) {
      this.action = action || 'post'
      this.logPath = logPath
      this.requestId = requestId || ''
      this.initialize()
    }

    initialize() {
      this.sendLog()
    }

    sendLog() {
      const params = {}

      if (this.requestId) {
        params.request_id = this.requestId
      }

      if (this.action === 'get') {
        $.get(this.logPath, params)
      } else {
        $.post(this.logPath, params)
      }
    }
  }

  // クリックイベントリスナーを設定する
  class ClickLogEventListener {
    constructor(element) {
      this.element = element
      this.clickHandler = null
      this.initialize()
    }

    initialize() {
      this.addClickEventListener()
    }

    addClickEventListener() {
      const clickLogData = parseClickLogData(this.element)
      if (!clickLogData) return

      // クリックイベントハンドラを定義
      this.clickHandler = (_e) => {
        const currentClickLogData = parseClickLogData(this.element)
        if (!currentClickLogData) return

        const countOnlyOnce = currentClickLogData.count_only_once
        const alreadySent = this.element.getAttribute('data-sent-log') === 'true'

        // count_only_once: true かつ既にログを送信済みの場合は何もしない
        if (countOnlyOnce === true && alreadySent) {
          return
        }

        // ログを送信
        new Logger(currentClickLogData.action, currentClickLogData.path, currentClickLogData.request_id)

        // count_only_once: true の場合、ログ送信後にdata-sent-log: trueを付与
        if (countOnlyOnce === true) {
          this.element.setAttribute('data-sent-log', 'true')
        }
      }

      // クリックイベントリスナーを追加
      this.element.addEventListener('click', this.clickHandler)
    }

    removeClickEventListener() {
      if (this.clickHandler) {
        this.element.removeEventListener('click', this.clickHandler)
        this.clickHandler = null
      }
    }
  }

  // 要素毎にClickLogEventListenerを設定する
  class SettingByElements {
    constructor() {
      this.settingByTags = [] // 例: [{ tag: 'hoge', clickLogEventListener: ClickLogEventListener }]
    }

    updateSettings() {
      const alreadySetTags = new Set(this.settingByTags.map(tk => tk.tag))
      const currentTargetElements = Array.from(document.querySelectorAll('[data-click-log]'))
      const processedData = this.processElements(currentTargetElements, alreadySetTags)

      // 新しい設定を追加
      processedData.elementsToAdd.forEach(({ element, clickLogData }) => {
        this.newSetting(element, clickLogData)
      })

      // 不要な設定を削除
      processedData.tagsToRemove.forEach(tag => this.deleteSetting(tag))
    }

    processElements(elements, alreadySetTags) {
      const currentTags = new Set()
      const elementsToAdd = []
      const tagsToStopMonitoring = []

      elements.forEach(element => {
        const clickLogData = parseClickLogData(element)
        if (!clickLogData?.tag) return

        const tag = clickLogData.tag
        const alreadySent = element.getAttribute('data-sent-log') === 'true'
        const isAlreadySet = alreadySetTags.has(tag)
        const shouldStopMonitoring = clickLogData.count_only_once === true && alreadySent

        currentTags.add(tag)

        // 設定を追加する要素を抽出
        if (!isAlreadySet && !shouldStopMonitoring) {
          elementsToAdd.push({ element, clickLogData })
        }

        // 監視を停止する要素を抽出
        if (isAlreadySet && shouldStopMonitoring) {
          tagsToStopMonitoring.push(tag)
        }
      })

      // DOMから削除された要素を抽出
      const tagsToDeleteFromDOM = Array.from(alreadySetTags).filter(tag => !currentTags.has(tag))

      // 削除対象のタグをマージ（重複を除去）
      const tagsToRemoveSet = new Set([...tagsToStopMonitoring, ...tagsToDeleteFromDOM])
      const tagsToRemove = Array.from(tagsToRemoveSet)

      return {
        elementsToAdd,
        tagsToRemove
      }
    }

    newSetting(element, cachedClickLogData = null) {
      const clickLogData = cachedClickLogData || parseClickLogData(element)
      if (!clickLogData?.tag) return

      const clickLogEventListener = new ClickLogEventListener(element)
      this.settingByTags.push({
        tag: clickLogData.tag,
        clickLogEventListener
      })
    }

    deleteSetting(deleteTargetTag) {
      const deleteTargetSetting = this.settingByTags.find((tk) => tk.tag === deleteTargetTag)
      if (!deleteTargetSetting) return

      deleteTargetSetting.clickLogEventListener.removeClickEventListener()
      this.settingByTags = this.settingByTags.filter((tk) => tk.tag !== deleteTargetTag)
    }
  }

  // MutationObserverを設定する
  class ClickLogMutationObserver {
    constructor(SettingByElements) {
      this.mutationObserver = null
      this.SettingByElements = SettingByElements
      this.initialize()
    }

    initialize() {
      this.newMutationObserver()
    }

    newMutationObserver() {
      // DOMの変更を監視し、要素が追加された場合にupdateSettingsを呼ぶ
      this.mutationObserver = new MutationObserver(() => {
        if (document.querySelectorAll('[data-click-log]').length === 0) return

        this.SettingByElements.updateSettings()
      })
      const options = {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-click-log']
      }
      this.mutationObserver.observe(document.body, options)
    }
  }

  $(window).on('load', function() {
    const settingByElements = new SettingByElements()
    settingByElements.updateSettings()
    new ClickLogMutationObserver(settingByElements)
  })
})
